import React from "react";

/**
 * ContactsTable — renders contact-form submissions with a Delete action.
 */
export default function ContactsTable({ submissions, onDelete }) {
  return (
    <table className="w-full">
      <thead className="bg-white/5">
        <tr>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Name</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Email</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Subject</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Date</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Actions</th>
        </tr>
      </thead>
      <tbody>
        {submissions.map((c) => (
          <tr key={c.id} className="border-t border-white/10">
            <td className="p-4 text-white text-sm">{c.name}</td>
            <td className="p-4 text-[#E8E4DC] text-sm">{c.email}</td>
            <td className="p-4 text-[#E8E4DC] text-sm">{c.subject}</td>
            <td className="p-4 text-[#E8E4DC] text-sm">{new Date(c.timestamp).toLocaleDateString()}</td>
            <td className="p-4">
              <button
                onClick={() => onDelete(c.id)}
                className="text-red-400 hover:text-red-300 text-sm"
                data-testid={`delete-sub-${c.id}`}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
